import { render, staticRenderFns } from "./status-bar.vue?vue&type=template&id=19923f9a&scoped=true"
import script from "./status-bar.ts?vue&type=script&lang=js&external"
export * from "./status-bar.ts?vue&type=script&lang=js&external"
import style0 from "./status-bar.vue?vue&type=style&index=0&id=19923f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19923f9a",
  null
  
)

export default component.exports